import { useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import PrimaryHomeHolderSC from "./primary_holder.styles.jsx";
import CardGrid from "../card_grid/card_grid.component.jsx";
import FloatingBackground from "./floating_background.jsx";
import GoogleSigninImage from '../../../assets/light/google_signup.svg'
import { linkWithPhoneNumber, RecaptchaVerifier, signInWithPopup } from "firebase/auth";
import { FirebaseAuthApp, GoogleFirebaseAuthProvider } from "../../../firebase.js";
import UserDetailsCard from "./components/user_details/user_details.components.jsx";
import PhoneValidationCard from "./components/phone_validation/phone_validation.components.jsx";
import CopyIcon from '../../../assets/copy_icon.svg';
import OpenLinkIcon from '../../../assets/open_link.svg';

const PrimaryHomeHolder = () => {
    const [currentUser, setUser] = useState({});
    const [otpValidationResult, setOTPValidationResult] = useState();
    const recaptchaRef = useRef(null);
    const firebaseUserRef = useRef(null);
    const [captchaId, setCaptchaID] = useState(null);

    const [cards, setCards] = useState([
        // { data: 5, card: SetupCompletion },
        { data: 4, card: UserInitateMessage },
        { data: 3, hasNext: true, card: PhoneValidationCard },
        { data: 2, hasNext: true, card: UserDetailsCard },
        { data: 1, isGoogleLogin: true, hasNext: true, card: GoogleSignupCard }
    ]);

    const [leaving, setLeaving] = useState(false);

    const handleNext = () => {
        setLeaving(true); // trigger dissolve animation

        // wait for animation to finish before removing
        setTimeout(() => {
            setCards(prev => prev.slice(0, -1));
            setLeaving(false);
        }, 300);
    };

    const initRecaptcha = (newCaptchID) => {
        if (captchaId !== newCaptchID) {
            if (recaptchaRef.current) {
                recaptchaRef.current.clear();
                recaptchaRef.current = null;
            }

            recaptchaRef.current = new RecaptchaVerifier(
                FirebaseAuthApp,
                newCaptchID,
                { size: 'invisible' }
            );
            setCaptchaID(newCaptchID)
        }
        return recaptchaRef.current;
    };

    const onOTPSend = async (captchID, user) => {
        try {
            if (!user || !captchID) return;

            if (user.accessToken && user.phoneNumber)
                return { status: true, alreadyLinked: true, accessToken: user.accessToken }

            const recaptchaVerifier = initRecaptcha(captchID)
            const result = await linkWithPhoneNumber(user, currentUser.whatsappNumber, recaptchaVerifier);
            setOTPValidationResult(result);
            return { status: true };
        } catch (error) {
            console.error("Error sending OTP:", error);
        }
        return { status: false };
    }

    const onOTPReceive = async (otp, user) => {
        try {
            if (!otpValidationResult) return;
            const result = await otpValidationResult.confirm(otp);
            return result.user.accessToken;
        } catch (error) {
            if (error?.code === "auth/provider-already-linked")
                return user.accessToken;

            console.error("Invalid OTP:", error);
        }
    }

    return <PrimaryHomeHolderSC>
        <div className="context-holder">
            <CardGrid />
        </div>
        <div className="card-holder">
            {cards.map((card, index) => {
                // calculate visual position class
                const pos = cards.length - index;
                const isFront = pos === 1;
                const AccountCard = card.card;
                return <AccountCard
                    key={card.data}
                    pos={pos}
                    card={card}
                    onOTPSend={onOTPSend}
                    onOTPReceive={onOTPReceive}
                    onNext={handleNext}
                    firebaseUserRef={firebaseUserRef}
                    currentUser={currentUser}
                    setUser={setUser}
                    isFront={isFront}
                    leaving={leaving && isFront}
                />;
            })}
        </div>
    </PrimaryHomeHolderSC>
}

const GoogleSignupCard = ({ pos, leaving, onNext, setUser }) => {
    const handleGoogle = async () => {

        try {
            const result = await signInWithPopup(FirebaseAuthApp, GoogleFirebaseAuthProvider);
            const user = result.user;

            const idToken = await user.getIdToken();
            if (user.email) {
                setUser({
                    name: user.displayName,
                    token: idToken,
                    email: user.email,
                    uid: user.uid,
                    googleUser: user
                });
                onNext();
            }
        } catch (error) {
            console.error(error)
        }
    };

    return <div className={`content-card card-${pos} ${leaving ? "leaving" : ""}`}>
        <div className="signup-card-title">
            Stay Consistent. Grow Every Day.
        </div>
        <div className="signup-card-subtitle">
            Get a thoughtful system design question on WhatsApp daily.
            Answer at your convenience. Build consistency, 365 days a year.
        </div>
        <img src={GoogleSigninImage} className="action-img" onClick={handleGoogle} />
    </div>
}

const UserInitateMessage = ({ pos, leaving, link = "https://wa.me/+918073589109?text=SUBSCRIBE" }) => {
    const [buttonText, setButtonText] = useState("Click to Copy URL");

    const handleCopy = async () => {
        try {
            // Copy the value to the clipboard
            await navigator?.clipboard?.writeText(link);

            // Update UI state
            setButtonText("Copied!");

            // Revert back to original text after 2 seconds
            setTimeout(() => {
                setButtonText("Click to Copy URL");
            }, 2000);
        } catch (err) {
            console.error("Failed to copy!", err);
        }
    };

    return <div className={`content-card card-${pos} ${leaving ? "leaving" : ""}`}>
        <div className="signup-card-title">
            Almost there
        </div>
        <div className="signup-card-subtitle">
            Scan the code below and message "SUBSCRIBE" to unlock your experience.
            <div className="signup-card-qr-code-holder" >
                <div className="signup-card-link" onClick={() => window.open(link, "_blank")}>
                    Visit Whatsapp <img src={OpenLinkIcon} />
                </div>
                <div className="signup-card-link" onClick={handleCopy}>
                    {buttonText} <img src={CopyIcon} />
                </div>
                <div>OR</div>
                <QRCodeSVG
                    value={link}
                    size={160}
                    bgColor={"#ffffff"}
                    fgColor={"#2c2b2b"}
                    level={"L"} // Error correction level: L, M, Q, H
                />
            </div>

        </div>
    </div>
}

// const SetupCompletion = ({ pos, leaving }) => {
//     return <div className={`content-card card-${pos} ${leaving ? "leaving" : ""}`}>
//         <div className="signup-card-title">
//             Welcome aboard for daily growth
//         </div>
//         <div className="signup-card-subtitle">
//             Your welcome message is on its way to WhatsApp. Shortly, you’ll receive one system-design question every day.
//             Let’s grow together, one small improvement at a time.
//             <br />
//             <br />
//             We’re available at <CopyEmail /> to hear your issues, challenges, testimonials, and feedback.
//         </div>
//     </div>
// }


function CopyEmail() {
    const email = "team@anahex.com";
    const [copied, setCopied] = useState(false);

    async function handleCopy() {
        await navigator.clipboard.writeText(email);
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
    }

    return (
        <span
            onClick={handleCopy}
            style={{
                cursor: "pointer",
                color: "#4f54e1",
                textDecoration: "underline"
            }}
        >
            {copied ? "Email Copied!" : email}
        </span>
    );
}


export default PrimaryHomeHolder;